import React from "react"
import { ArrowLeftRight } from "lucide-react"

const FormSwapCityButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="
        bg-white border border-fresh-green rounded-md p-1
        transition-all cursor-pointer
        flex items-center justify-center
        w-10 h-10 sm:w-auto sm:h-auto
      "
    >
      {/* На мобиле иконка повёрнута на 90° — свап вертикальный (верх/низ) */}
      <ArrowLeftRight
        strokeWidth={1}
        className="w-8 h-5 rotate-90 sm:rotate-0 transition-transform duration-200"
      />
    </button>
  )
}

export default FormSwapCityButton
